import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {MomentModule} from 'angular2-moment/module'
import { NgwService } from '../../app/ngw.service';

import { SettingsPage } from '../settings/settings';
import {MyGlobals} from '../../app/globals';
import * as moment from 'moment';

@Component({
  selector: 'create-ngw-game',
  templateUrl: 'createNgwGame.html',
   styles: [
     '.logo { width: 80px; height: 80px; background-repeat: no-repeat; background-position: 50% 50%; float: left; }',
     '.logoAt {width: 20px; height: 80px; float: left; line-height: 80px }'
     ]
})
export class CreateNgwGamePage  implements OnInit {

loading:Boolean = true;
gameData = null;
myGlobals:MyGlobals;

 constructor(public navCtrl: NavController, public http: Http, private ngwService: NgwService) {
    this.myGlobals = new MyGlobals();
  }

  ngOnInit(){
    this.loadGames().subscribe(data => {
        this.gameData = data; 
        this.loading = false;
    });
  }

  loadGames() {
      console.log("requesting")
      var url = "/api/schedule?startDate=2017-04-19&endDate=2017-04-24&expand=schedule.teams,schedule.linescore,schedule.broadcasts.all,schedule.ticket,schedule.game.content.media.epg,schedule.radioBroadcasts,schedule.game.seriesSummary,seriesSummary.series&leaderCategories=&leaderGameTypes=R&site=en_nhlCA&teamId=&gameType=&timecode=";
      url = "http://statsapi.web.nhl.com/api/v1/schedule?startDate=" + moment().add(this.myGlobals.daysToGoBack * -1, "d").format("YYYY-MM-DD") + "&endDate=" + moment().format("YYYY-MM-DD") + "&expand=schedule.teams,schedule.linescore,schedule.broadcasts.all,schedule.ticket,schedule.game.content.media.epg,schedule.radioBroadcasts,schedule.game.seriesSummary,seriesSummary.series&leaderCategories=&leaderGameTypes=R&site=en_nhlCA&teamId=&gameType=&timecode=";
      //url = "/index.html";
      
      
      return this.http.get( url)
      .map((res:Response)=>  res.json());//.subscribe(data => {this.myText = data; console.log("Back", data)});;
        
    }

    createNgwGame(nhlGame) {
      this.ngwService.createNewGame(nhlGame);
      this.navCtrl.push(SettingsPage, {
        isCreating: true
      });   
      //this.navCtrl.setRoot(TabsPage);
      
    }

    
      
  


}



// WEBPACK FOOTER //
// ./src/pages/CreateNgwGame/CreateNgwGame.ts